import axios from 'axios';
import { Component } from 'react';


class GetIssues extends Component {
  constructor(props) {
    super(props);

    this.state = {
      response: null
    };

    this.getPage = this.getPage.bind(this);
  }

  componentDidMount() {
    this.getPage(0);
  }

  getPage(pageNum) {
    axios.get('https://open-issues.s3-eu-west-1.amazonaws.com/open_issues_' + pageNum + '.json')
      .then((response) => {
        this.setState({
          response: response.data
        });
      });
  }

  render() {
    const { response } = this.state;
    const { wrappedRender } = this.props;
    return wrappedRender(response, this.getPage);
  }

}

export default GetIssues;
